import CardInfo from './CardInfo';
import Hero from './Hero';
import Refill from './Refill';
Landing.propTypes = {};

function Landing(props) {
    return (
        <div>
            <Hero></Hero>
            <CardInfo />
            <Refill />
        </div>
    );
}

export default Landing;
